import 'core-js';
import 'react-app-polyfill/ie11';
import '@fever/ui/theme.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { initErrorLogService } from 'sentry';
import App from './App';
import 'locale/i18n';
import 'common/utils/extendDayjs';
import * as serviceWorker from './serviceWorker';

initErrorLogService();

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

/* If you want your app to work offline and load faster, you can change
 unregister() to register() below. Note this comes with some pitfalls.
 Learn more about service workers: https://bit.ly/CRA-PWA
*/
serviceWorker.unregister();
